import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "row w-50" }
const _hoisted_4 = {
  class: "card-title d-flex flex-column",
  style: {"width":"200px"}
}
const _hoisted_5 = { class: "fs-2hx fw-bold text-dark me-2 lh-1 ls-n2" }
const _hoisted_6 = { class: "text-gray-400 pt-1 fw-semibold fs-6" }
const _hoisted_7 = {
  class: "card-title d-flex flex-column",
  style: {"width":"200px"}
}
const _hoisted_8 = { class: "fs-2hx fw-bold text-dark me-2 lh-1 ls-n2" }
const _hoisted_9 = { class: "text-gray-400 pt-1 fw-semibold fs-6" }
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "card-body py-3" }
const _hoisted_14 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.countInscripciones), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("tabla.cursosInscripcionesListado.contador.inscripciones")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.inscripcionesActivas), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("tabla.cursosInscripcionesListado.contador.inscritos")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          style: {"width":"300px"},
          placeholder: _ctx.$t('tabla.buscador.placeholder')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_download_excel, {
          data: _ctx.inscripcionesListado,
          labels: _ctx.csvLabels,
          fields: _ctx.csvFields,
          name: _ctx.csvName
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_11, [
              _createElementVNode("i", {
                class: "fas fa-file-excel fs-3",
                title: _ctx.$t('tabla.cursosInscripcionesListado.boton.imprimir')
              }, null, 8, _hoisted_12)
            ])
          ]),
          _: 1
        }, 8, ["data", "labels", "fields", "name"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_table, {
        data: _ctx.inscripcionesListado,
        style: {"width":"100%"},
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.cursosInscripcionesListado.cabecera.fecha'),
            prop: "createdOn",
            formatter: _ctx.toLocaleDateString,
            sortable: "",
            "min-width": "120",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                "data-bs-toggle": "tooltip",
                title: _ctx.formatHour(scope.row.createdOn)
              }, _toDisplayString(_ctx.formatLongDate(scope.row.createdOn)), 9, _hoisted_14)
            ]),
            _: 1
          }, 8, ["label", "formatter"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.cursosInscripcionesListado.cabecera.alumno'),
            prop: "alumno",
            sortable: "",
            "show-overflow-tooltip": "",
            "min-width": "180"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.cursosInscripcionesListado.cabecera.dni'),
            prop: "dni",
            sortable: "",
            "min-width": "110",
            width: "110"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.cursosInscripcionesListado.cabecera.telefono'),
            prop: "telefono",
            sortable: "",
            "min-width": "120",
            width: "120",
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.cursosInscripcionesListado.cabecera.email'),
            prop: "email",
            sortable: "",
            "show-overflow-tooltip": "",
            "min-width": "180"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.cursosInscripcionesListado.cabecera.localidad'),
            prop: "localidad",
            sortable: "",
            "min-width": "150",
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.cursosListado.cabecera.perfil'),
            sortable: "",
            prop: "perfilTexto",
            "min-width": "120",
            width: "120",
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.profesionales.cabecera.estado'),
            sortable: "",
            "sort-method": _ctx.sortInscripcionEstado,
            "min-width": "200",
            width: "200",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_dropdown, { class: "me-3" }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (scope.row.estado !== _ctx.InscripcionEstado.inscrito)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 0,
                            onClick: ($event: any) => (_ctx.onInscrito(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.cursosInscripcionesListado.inscrito.button"
                      )), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (scope.row.estado !== _ctx.InscripcionEstado.finalizado)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 1,
                            onClick: ($event: any) => (_ctx.onFinalizado(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.cursosInscripcionesListado.finalizado.button"
                      )), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (scope.row.estado !== _ctx.InscripcionEstado.listaDeEspera)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 2,
                            onClick: ($event: any) => (_ctx.onListaDeEspera(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.cursosInscripcionesListado.listaDeEspera.button"
                      )), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (scope.row.estado !== _ctx.InscripcionEstado.cancelado)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 3,
                            onClick: ($event: any) => (_ctx.onCancelado(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.cursosInscripcionesListado.cancelado.button"
                      )), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (scope.row.estado !== _ctx.InscripcionEstado.abandono)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 4,
                            onClick: ($event: any) => (_ctx.onAbandono(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.cursosInscripcionesListado.abandono.button"
                      )), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    class: "ml-2",
                    type: _ctx.getTagType(scope.row.estado)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`inscripciones.estado.${scope.row.estado}`)) + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["label", "sort-method"]),
          _createVNode(_component_el_table_column, {
            width: "80",
            align: "center",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "text",
                onClick: ($event: any) => (_ctx.verSolicitud(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("tabla.cursosInscripcionesListado.fila.ver")), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}